import {Controller} from "@hotwired/stimulus"
import Quill from "quill"
import {AlignStyle} from "quill/formats/align"

Quill.register(AlignStyle, true)

export default class extends Controller {
  static targets = ["editor", "result"]

  connect() {
    const options = {
      theme: "snow",
      modules: {
        toolbar: {
          container: [
            [{header: [1, 2, 3, false]}],
            ["bold", "italic", "underline", "strike"],
            [{align: ["", "center", "right", "justify"]}],
            [{list: "ordered"}, {list: "bullet"}],
            [{indent: "-1"}, {indent: "+1"}],
            ["blockquote", "code-block"],
            ["link", "image"],
            ["clean"]
          ]
        }
      }
    }

    this.quill = new Quill(this.editorTarget, options)

    this.quill.on("text-change", () => {
      const html = this.quill.getSemanticHTML().replaceAll("&nbsp;", " ")
      this.resultTarget.value = html
    })
  }

  // #imageHandler() {
  //   const url = prompt("URL изображения:")
  //   if (!url) return
  //   const range = this.quill.getSelection(true)
  //   this.quill.insertEmbed(range.index, "image", url)
  //   this.quill.setSelection(range.index + 1)
  // }

  disconnect() {
    this.quill = null
  }
}
